import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import './Register.css';
import { EyeIcon, EyeOffIcon } from '../components/icons';

const PASSWORD_REQUIREMENTS = [
  'Au moins 6 caractères',
  'Au moins une lettre majuscule',
  'Au moins un caractère spécial (ex: !, ?, @, #)'
];

const CGV_CONTENT = [
  {
    title: 'Article 1 : Société',
    text: `Global Sourcing Solution Group est une Société à Actions Simplifiée dont le siège social est situé à Fresnes (94260), 68 boulevard Jean Jaurès.`
  },
  {
    title: 'Article 2 : Qui êtes-vous pour nous ?',
    text: `Les offres présentées par globalsourcingsolutiongroup.com sont réservées à une clientèle professionnelle particulière : types sociétés, groupe, cavistes.
Le dispositif du Code de santé publique interdit la vente d’alcool aux moins de 18 ans. Par conséquent, l’ouverture d’un compte de commande ne peut se faire qu’au profit d’une personne majeure ayant pleine capacité juridique. De plus à chaque commande, lors de la validation et avant le paiement, le client en acceptant ces présentes CGV reconnaitra de nouveau sa majorité (un justificatif pourra vous être demandé suivant un contrôle aléatoire).
Lors de la création d’un compte, vous vous engagez à fournir des informations exactes et complètes quant à vos coordonnées personnelles ainsi que toute autre information nécessaire à l’accès aux services et à la livraison. Vous devez veiller à les mettre à jour régulièrement, spécialement en ce qui concerne les livraisons.
Un compte est personnel et son accès ne peut être prêté, cédé, remis à tout tiers. Cet accès s’effectue au moyen d’un identifiant et d’un mot de passe dont la conservation est sous votre responsabilité exclusive. Au moindre doute sur leur intégrité ou sur la survenance d’une fraude, vous devez nous prévenir afin que nous soyons en mesure d’en régénérer de nouveaux sécurisés.`
  },
  {
    title: 'Article 3 : Que régissent les présentes CGV ?',
    text: `Les conditions générales s’appliquent pour tout achat réalisé auprès de la société GSSG sur sa boutique en ligne. Le fait de passer commande implique l’adhésion pleine et entière du client aux présentes CGV. Seul un accord écrit stipulant des conditions spéciales permettrait de déroger aux CGV. Nous vous invitons à prendre connaissance de la version en vigueur au jour de votre commande et à la sauvegarder.`
  },
  {
    title: 'Article 4 : Modalités de la commande',
    text: `Toutes les commandes sont effectuées sur le site www.globalsourcingsolutiongroup.com. Après validation de votre panier, vous recevez par mail le récapitulatif de la commande et êtes contacté sous 24h pour organiser l’expédition et le paiement. À des fins de sécurisation, des justificatifs d’identité ou d’entreprise peuvent être demandés. GSSG se réserve le droit d’annuler toute commande présentant des anomalies ou un litige antérieur. Les produits restent la propriété de GSSG jusqu’au règlement intégral des factures.`
  },
  {
    title: 'Article 5 : Prix de la commande',
    text: `Les prix affichés sur les fiches produits sont en euros, toutes taxes comprises, et peuvent varier selon la demande ou la destination. Les frais de transport sont calculés séparément selon la quantité, la destination et le délai souhaité.`
  },
  {
    title: 'Article 6 : Modes de règlement',
    text: `Les paiements peuvent se faire par virement bancaire (coordonnées transmises dans l’email de confirmation) ou via PayPal, dans les limites autorisées par ce service.`
  },
  {
    title: 'Article 7 : Rupture de stock',
    text: `En cas de rupture, GSSG vous informe et propose soit un remplacement équivalent, soit un remboursement/avoir. En cas de rupture temporaire, vous pouvez patienter, demander l’annulation partielle ou totale de votre commande.`
  },
  {
    title: 'Article 8 : Livraison',
    text: `Après paiement, la commande est expédiée à l’adresse renseignée (il vous incombe d’en vérifier l’exactitude). En cas de dommage, vérifiez les colis devant le transporteur et formulez des réserves circonstanciées ; prévenez GSSG sous 48h. Pour le retrait sur site, présentez votre numéro de commande et une pièce d’identité. Le client dispose d’un délai maximum d’un mois pour retirer sa commande. Ce délai passé la société GSSG n’est plus responsable de la commande.`
  }
];

const PHONE_CODES = [
  { value: '+27', label: '🇿🇦 Afrique du Sud (+27)' },
  { value: '+213', label: '🇩🇿 Algérie (+213)' },
  { value: '+49', label: '🇩🇪 Allemagne (+49)' },
  { value: '+244', label: '🇦🇴 Angola (+244)' },
  { value: '+43', label: '🇦🇹 Autriche (+43)' },
  { value: '+32', label: '🇧🇪 Belgique (+32)' },
  { value: '+229', label: '🇧🇯 Bénin (+229)' },
  { value: '+267', label: '🇧🇼 Botswana (+267)' },
  { value: '+359', label: '🇧🇬 Bulgarie (+359)' },
  { value: '+226', label: '🇧🇫 Burkina Faso (+226)' },
  { value: '+257', label: '🇧🇮 Burundi (+257)' },
  { value: '+237', label: '🇨🇲 Cameroun (+237)' },
  { value: '+238', label: '🇨🇻 Cap-Vert (+238)' },
  { value: '+236', label: '🇨🇫 Centrafrique (+236)' },
  { value: '+357', label: '🇨🇾 Chypre (+357)' },
  { value: '+269', label: '🇰🇲 Comores (+269)' },
  { value: '+242', label: '🇨🇬 Congo (+242)' },
  { value: '+225', label: "🇨🇮 Côte d'Ivoire (+225)" },
  { value: '+385', label: '🇭🇷 Croatie (+385)' },
  { value: '+45', label: '🇩🇰 Danemark (+45)' },
  { value: '+253', label: '🇩🇯 Djibouti (+253)' },
  { value: '+20', label: '🇪🇬 Égypte (+20)' },
  { value: '+34', label: '🇪🇸 Espagne (+34)' },
  { value: '+372', label: '🇪🇪 Estonie (+372)' },
  { value: '+291', label: '🇪🇷 Érythrée (+291)' },
  { value: '+251', label: '🇪🇹 Éthiopie (+251)' },
  { value: '+358', label: '🇫🇮 Finlande (+358)' },
  { value: '+33', label: '🇫🇷 France (+33)' },
  { value: '+241', label: '🇬🇦 Gabon (+241)' },
  { value: '+220', label: '🇬🇲 Gambie (+220)' },
  { value: '+233', label: '🇬🇭 Ghana (+233)' },
  { value: '+240', label: '🇬🇶 Guinée équatoriale (+240)' },
  { value: '+224', label: '🇬🇳 Guinée (+224)' },
  { value: '+245', label: '🇬🇼 Guinée-Bissau (+245)' },
  { value: '+30', label: '🇬🇷 Grèce (+30)' },
  { value: '+36', label: '🇭🇺 Hongrie (+36)' },
  { value: '+353', label: '🇮🇪 Irlande (+353)' },
  { value: '+354', label: '🇮🇸 Islande (+354)' },
  { value: '+39', label: '🇮🇹 Italie (+39)' },
  { value: '+254', label: '🇰🇪 Kenya (+254)' },
  { value: '+266', label: '🇱🇸 Lesotho (+266)' },
  { value: '+371', label: '🇱🇻 Lettonie (+371)' },
  { value: '+231', label: '🇱🇷 Libéria (+231)' },
  { value: '+218', label: '🇱🇾 Libye (+218)' },
  { value: '+370', label: '🇱🇹 Lituanie (+370)' },
  { value: '+352', label: '🇱🇺 Luxembourg (+352)' },
  { value: '+261', label: '🇲🇬 Madagascar (+261)' },
  { value: '+265', label: '🇲🇼 Malawi (+265)' },
  { value: '+223', label: '🇲🇱 Mali (+223)' },
  { value: '+356', label: '🇲🇹 Malte (+356)' },
  { value: '+212', label: '🇲🇦 Maroc (+212)' },
  { value: '+230', label: '🇲🇺 Maurice (+230)' },
  { value: '+222', label: '🇲🇷 Mauritanie (+222)' },
  { value: '+258', label: '🇲🇿 Mozambique (+258)' },
  { value: '+264', label: '🇳🇦 Namibie (+264)' },
  { value: '+227', label: '🇳🇪 Niger (+227)' },
  { value: '+234', label: '🇳🇬 Nigéria (+234)' },
  { value: '+47', label: '🇳🇴 Norvège (+47)' },
  { value: '+256', label: '🇺🇬 Ouganda (+256)' },
  { value: '+31', label: '🇳🇱 Pays-Bas (+31)' },
  { value: '+48', label: '🇵🇱 Pologne (+48)' },
  { value: '+351', label: '🇵🇹 Portugal (+351)' },
  { value: '+243', label: '🇨🇩 République démocratique du Congo (+243)' },
  { value: '+40', label: '🇷🇴 Roumanie (+40)' },
  { value: '+44', label: '🇬🇧 Royaume-Uni (+44)' },
  { value: '+250', label: '🇷🇼 Rwanda (+250)' },
  { value: '+239', label: '🇸🇹 São Tomé-et-Principe (+239)' },
  { value: '+221', label: '🇸🇳 Sénégal (+221)' },
  { value: '+248', label: '🇸🇨 Seychelles (+248)' },
  { value: '+232', label: '🇸🇱 Sierra Leone (+232)' },
  { value: '+421', label: '🇸🇰 Slovaquie (+421)' },
  { value: '+386', label: '🇸🇮 Slovénie (+386)' },
  { value: '+252', label: '🇸🇴 Somalie (+252)' },
  { value: '+249', label: '🇸🇩 Soudan (+249)' },
  { value: '+211', label: '🇸🇸 Soudan du Sud (+211)' },
  { value: '+46', label: '🇸🇪 Suède (+46)' },
  { value: '+41', label: '🇨🇭 Suisse (+41)' },
  { value: '+255', label: '🇹🇿 Tanzanie (+255)' },
  { value: '+235', label: '🇹🇩 Tchad (+235)' },
  { value: '+420', label: '🇨🇿 Tchéquie (+420)' },
  { value: '+228', label: '🇹🇬 Togo (+228)' },
  { value: '+216', label: '🇹🇳 Tunisie (+216)' },
  { value: '+90', label: '🇹🇷 Turquie (+90)' },
  { value: '+260', label: '🇿🇲 Zambie (+260)' },
  { value: '+263', label: '🇿🇼 Zimbabwe (+263)' }
];


function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    companyName: '',
    kbis: '',
    email: '',
    phoneCountryCode: '+33',
    phoneNumber: '',
    city: '',
    postalCode: '',
    streetAddress: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const toastTimerRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(null);
  const [acceptedCGV, setAcceptedCGV] = useState(false);
  const [showCGVModal, setShowCGVModal] = useState(false);

  useEffect(() => {
    return () => {
      if (toastTimerRef.current) {
        clearTimeout(toastTimerRef.current);
      }
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'postalCode') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 5);
      setForm({ ...form, postalCode: digitsOnly });
      return;
    }
    setForm({ ...form, [name]: value });
    if (name === 'password') {
      if (value === '') {
        setIsPasswordValid(null);
      } else {
        const passwordPattern = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{6,}$/;
        setIsPasswordValid(passwordPattern.test(value));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const passwordPattern = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{6,}$/;
    const passwordIsValid = passwordPattern.test(form.password);
    setIsPasswordValid(passwordIsValid ? true : false);
    if (!passwordIsValid) {
      setError("Le mot de passe doit contenir au moins 6 caractères, une majuscule et un caractère spécial.");
      return;
    }

    if ((form.postalCode || '').length !== 5) {
      setError('Le code postale doit comporter exactement 5 chiffres.');
      return;
    }

    if (!acceptedCGV) {
      setError('Vous devez accepter les Conditions Générales de Vente pour vous inscrire.');
      return;
    }

    try {
      const res = await axios.post('http://localhost:5001/api/users/register', {
        companyName: form.companyName,
        kbis: form.kbis,
        email: form.email,
        phoneCountryCode: form.phoneCountryCode,
        phoneNumber: form.phoneNumber,
        city: form.city,
        postalCode: form.postalCode,
        address: form.streetAddress,
        password: form.password
      });
      const pendingMessage = res?.data?.message || 'Votre demande de création a bien été soumise. Un administrateur la validera dans un délai de 24H.';
      setSuccess(pendingMessage);
      setToastMessage(pendingMessage);
      if (toastTimerRef.current) {
        clearTimeout(toastTimerRef.current);
      }
      toastTimerRef.current = setTimeout(() => {
        setToastMessage('');
        toastTimerRef.current = null;
      }, 4000);
      setForm({
        companyName: '',
        kbis: '',
        email: '',
        phoneCountryCode: '+33',
        phoneNumber: '',
        city: '',
        postalCode: '',
        streetAddress: '',
        password: ''
      });
      setAcceptedCGV(false);
    } catch (err) {
      setError(err.response?.data?.error || "Erreur lors de l'inscription");
    }
  };

  return (
    <>
    <div className="register-page">
      <div className="register-brand">Global Sourcing Solution Group</div>
      {toastMessage && (
      <div className="register-toast" role="status">{toastMessage}</div>
    )}
      <div className="register-card">
        <div className="register-card__intro">
          <h2>Déjà inscrit ?</h2>
          <p>Connectez-vous pour accéder à votre cave et suivre vos commandes.</p>
          <button type="button" className="register-btn register-btn--ghost" onClick={() => navigate('/login')}>
            Se connecter
          </button>
        </div>
        <div className="register-card__form">
          <h2>Créer un compte</h2>
          <p className="register-subtitle">
            Inscrivez-vous pour découvrir la sélection Global Sourcing Solution Group et gérer vos achats en toute simplicité.
          </p>
          <form className="register-form" onSubmit={handleSubmit}>
            <div className="register-field">
              <label htmlFor="companyName">Nom de l'entreprise<span className="register-required">*</span></label>
              <input
                id="companyName"
                type="text"
                name="companyName"
                value={form.companyName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="kbis">KBIS<span className="register-required">*</span></label>
              <input
                id="kbis"
                type="text"
                name="kbis"
                value={form.kbis}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="phoneCountryCode">Indicatif téléphonique du pays</label>
              <select
                id="phoneCountryCode"
                name="phoneCountryCode"
                value={form.phoneCountryCode}
                onChange={handleChange}
              >
                <option value="">Sélectionnez un indicatif</option>
                {PHONE_CODES.map((code) => (
                  <option key={code.value} value={code.value}>
                    {code.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="register-field">
              <label htmlFor="phoneNumber">Numéro de téléphone</label>
              <input
                id="phoneNumber"
                type="tel"
                name="phoneNumber"
                value={form.phoneNumber}
                onChange={handleChange}
                placeholder="612345678"
              />
            </div>
            <div className="register-field">
              <label htmlFor="email">Adresse email<span className="register-required">*</span></label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="city">Ville<span className="register-required">*</span></label>
              <input
                id="city"
                type="text"
                name="city"
                value={form.city}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="streetAddress">Numéro et voie<span className="register-required">*</span></label>
              <input
                id="streetAddress"
                type="text"
                name="streetAddress"
                value={form.streetAddress}
                onChange={handleChange}
                pattern="[A-Za-z0-9\s\-']+"
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="postalCode">Code postale<span className="register-required">*</span></label>
              <input
                id="postalCode"
                type="text"
                name="postalCode"
                value={form.postalCode}
                onChange={handleChange}
                required
              />
            </div>
            <div className="register-field">
              <label htmlFor="password">Mot de passe<span className="register-required">*</span></label>
              <div className="register-password-input">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  className={isPasswordValid === null ? '' : isPasswordValid ? 'is-valid' : 'is-invalid'}
                  required
                />
                <button
                  type="button"
                  className="register-password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-pressed={showPassword}
                  aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
              {isPasswordValid === false && (
                <div className="password-requirements password-requirements--error">
                  <p>Veuillez respecter les conditions suivantes :</p>
                  <ul>
                    {PASSWORD_REQUIREMENTS.map((requirement) => (
                      <li key={requirement}>{requirement}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="register-checkbox-wrapper">
              <label className="register-checkbox">
                <input
                  type="checkbox"
                  checked={acceptedCGV}
                  onChange={(e) => setAcceptedCGV(e.target.checked)}
                />
                <span>
                  J'accepte les{' '}
                  <button
                    type="button"
                    className="register-cgv-link"
                    onClick={() => setShowCGVModal(true)}
                  >
                    Conditions Générales de Vente
                  </button>
                  .
                </span>
              </label>
            </div>
            <button type="submit" className="register-btn">S'inscrire</button>
            {error && <p className="register-message register-message--error">{error}</p>}
            {success && <p className="register-message register-message--success">{success}</p>}
          </form>
        </div>
      </div>
    </div>
    {showCGVModal && (
        <div className="register-cgv-modal" role="dialog" aria-modal="true">
          <div className="register-cgv-modal__content">
            <header className="register-cgv-modal__header">
              <h3>Conditions Générales de Vente</h3>
              <button
                type="button"
                className="register-cgv-modal__close"
                onClick={() => setShowCGVModal(false)}
                aria-label="Fermer"
              >
                ×
              </button>
            </header>
            <div className="register-cgv-modal__body">
              <div className="register-cgv-modal__text">
                {CGV_CONTENT.map((article) => (
                  <section key={article.title}>
                    <h4>{article.title}</h4>
                    {article.text.split('\n').map((paragraph, idx) => (
                      <p key={`${article.title}-${idx}`}>{paragraph}</p>
                    ))}
                  </section>
                ))}
              </div>
              <p className="register-cgv-modal__fallback">
                Télécharger la version complète :{' '}
                <a href="/CGV.docx" target="_blank" rel="noopener noreferrer">
                  CGV (fichier .docx)
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Register;
